import type { Ssm5RecentConnection } from '@packages/domain/ssm5';

import { GetLastConnection } from '@packages/domain/ssm5';
import { container } from '@web/services/container';

import { useLookup } from './use-lookup';

const [$getLastConnection] = container.resolveOperations(GetLastConnection);

/** The lookup has no input: one constant key runs it once per mount, for the signed-in technician. */
const SIGNED_IN_TECHNICIAN = 'signedInTechnician';

/**
 * The technician's most recent eligible SSM5 connection.
 *
 * @returns the connection once looked up; undefined without one, while loading, or when the lookup fails
 */
export function useLastConnection(): Ssm5RecentConnection | undefined {
    return useLookup(SIGNED_IN_TECHNICIAN, lookupLastConnection);
}

/**
 * Look the technician's most recent eligible connection up.
 *
 * @param _technician - the constant key; the technician comes from the authenticated session
 * @param signal - aborts the lookup
 * @returns the connection, or undefined when the technician has none
 */
function lookupLastConnection(_technician: string, signal: AbortSignal): Promise<Ssm5RecentConnection | undefined> {
    return $getLastConnection({ signal });
}
